<template>
    <b-card no-body>

        <b-modal id="assign" title="Ata" no-close-on-esc no-close-on-backdrop>
            <assign-report-user v-model="assignData"></assign-report-user>
            <template #modal-footer><v-executer :action="assign" text="Ata" :loading="loading"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { ReportApi } from '@/api/report'
import AssignReportUser from './components/AssignReportUser.vue'

export default {
    components:{
        BCard,
        AssignReportUser
    },
    data(){
        return {
            loading:false,
            fields:[
                {name:'Kullanıcı',key:'UserFullName',thClass:'w-50',sortable:true},
                {name:'Rapor Türü',key:'ReportType',thClass:'w-50',sortable:true},
            ],
            buttons:[
                { text:"Atamayı Kaldır",key:"edit",icon:"XSquareIcon",variant:"danger",action:this.removeAssign }
            ],
            assignData:{
                Id:null,
                UserId:null,
                ReportTypes:[]
            }
        }
    },
    methods:{
        provider(){
            return ReportApi.AssignList()
        },
        clearForm(){
            this.assignData.Id = null
            this.assignData.UserId = null
            this.assignData.ReportTypes = []
        },
        createNew(){
            this.clearForm()
            this.$showModal('assign')
        },
        assign(){
            this.loading = true
            ReportApi.Assign(this.assignData).then(res=>{
                this.loading = false
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('assign')   
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        removeAssign(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.UserFullName} kullanıcılarının rapor atamasını silecektir.`).then(result=>{
                if(result){
                    ReportApi.RemoveAssign(item.Id).then(res=>{
                        this.$result(res)
                        if(res.data.Success){
                            this.$refs.table.refresh()
                        }
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>